<template>
    <div class="container">
        <div class="main">
            <div class="model_image"  @click="goModelDetail">
                <el-image :src="model" style="width: 83.6%; aspect-ratio: 1/1; border-radius: 10px; cursor: pointer;"></el-image>
            </div>
            <div class="model_name">
                <span :title="name ? name : '未知设备'">{{ name ? name : '未知设备' }}</span>
            </div>
            <div></div>
            <div class="model_info">
                <div class="info_head">
                    <img :src="userIcon ? userIcon : require('../../assets/image/资源 38.png')" style="width: 1.5rem; height: 1.5rem; border-radius: 90%;">
                </div>
                <span style="white-space: nowrap; font-size: 0.9rem; margin-left: 1%;">{{ user ? user : '匿名用户' }}</span>

                <div v-show="!isCollection" class="info_download" @click="addMyCollection(id)">
                    <span>加入收藏</span>
                </div>
                <div v-show="isCollection" class="info_download" @click="deleteMyCollection(id)">
                    <span>取消收藏</span>
                </div>
                <!-- <div class="info_collection">
                    <i class="el-icon-star-on" v-if="isCollection" @click="handleCollection"></i>
                    <i class="el-icon-star-off" v-else @click="handleCollection"></i>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { changeCollectState } from '../../util/index'
export default {
    data(){
        return{
            isCollection:this.isModelCollection,
            // modelImg:'../../assets/model.jpg'
        }
    },
    name: "ModelShowFrame",
    props:{
        name: String,
        model:String,
        userIcon: String,
        user: String,
        id: String,
        isModelCollection: Boolean
    },
    methods:{
        handleCollection(){
            // this.isCollection = !this.isCollection
        },
        goModelDetail(){
            // console.log(this.$route.path);
            // if(this.$route.path.includes('/models_detail')){
            //     this.$router.push({ path:'/models_detail', query:{id:this.id,name:this.name, type:this.type}})
            //     // window.location.reload()
            //     let info = {id:this.id,name:this.name, type:this.type}
            //     this.$bus.$emit('reloadModel', info)
            //     console.log('走的包含');
            // }else{
            //     this.$router.push({ path:'/models_detail', query:{id:this.id,name:this.name, type:this.type}})
            //     console.log('走的不包含');
            // }
            window.open('/models_detail?id='+this.id)
        },
        deleteMyCollection(id){
            let obj = {
                token: window.localStorage.getItem('userToken')
            }
            console.log("加入模型：",id);
            changeCollectState(id, { isFavorite: false}, obj.token).then(res=>{
                if(res.code === 200){
                    this.$message({
                        message: '已取消收藏',
                        type: 'success'
                    })
                    this.isCollection = false
                } else if(res.code === '2'){
                    this.$message('请先登录')
                    let info = { isOpen : true}
                    setTimeout(() => {
                        this.$bus.$emit('openDialog', info)
                    }, 1000);
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        addMyCollection(id){
            let obj = {
                token: window.localStorage.getItem('userToken')
            }
            console.log("加入模型：",id);
            changeCollectState(id, {isFavorite: true}, obj.token).then(res=>{
                if(res.code === 200){
                    this.$message({
                        message: '收藏成功',
                        type: 'success'
                    })
                    this.isCollection = true
                } else if(res.code === 300){
                    this.$message('请先登录')
                    let info = { isOpen : true}
                    setTimeout(() => {
                        this.$bus.$emit('openDialog', info)
                    }, 1000);
                }else{
                    this.$message.error(res.message)
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
*{
    list-style: none;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.container:hover{
    background-color: #fff;
}
.container{
    float: left;
    border-radius: 10px;
    width: 18%;
    aspect-ratio: 0.76/1;
    // height: 400px;
    transition: all .5s;
    // height: 500px;
    margin: 1% 1%;
    background: #A2A2A2;
    // &:hover {
    //     transform: translateY(-3px);
    //     box-shadow: 1px 1px 20px #999;
    // }
    .main{
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        // background-color: #32ff2b;
        padding-bottom: 8%;
        .model_image {
            width: 100%;
            height: 100%;
            padding-top: 2rem;
            // position: relative;
            // background-color: #54defc;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .model_name{
            // background-color: #32ff2b;
            padding-top: 0.5rem;
            text-align: center;
            span{
                font-size: 0.9rem;
                font-family: AliRegular;
                white-space: nowrap; /* 禁止换行 */
                overflow: hidden; /* 隐藏超出部分 */
                text-overflow: ellipsis; /* 超出部分显示省略号 */
                display: inline-block; /* 保持行内块状 */
                max-width: 200px; /* 设置最大宽度，根据需要调整 */
            }
        }
        .model_info{
            display: flex;
            // justify-content: space-between;
            height: 15%;
            width: 80%;
            align-items: center;
            border-top: 1px solid #B4B4B4;
            padding: 1rem 0;
            margin-top: 0.5rem;
            .info_download{
                width: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #969696;
                border-radius: 10px;
                margin-left: 15%;
                padding: 0.2rem 0;
                span{
                    letter-spacing: 1px;
                    font-size: 0.9rem;
                    color: #fff;
                    cursor: pointer;
                }
            }
            .info_download:hover{
                background-color: #54ceec;
            }
            .info_collection{
                height: 44%;
            }
        }
    }
}
</style>